// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as SpotEstimateStore$PorterinFeature from "../../../../../../shared/core/constants/SpotEstimateStore.mjs";
import * as LocationInfoActionCmpModuleScss from "../styles/LocationInfoActionCmp.module.scss";

var styles = LocationInfoActionCmpModuleScss;

function ConfirmLocationActionCmp(Props) {
  var landmark = Props.landmark;
  var on_confirm = Props.on_confirm;
  var waypoint = Props.waypoint;
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: styles.address
                }, landmark), React.createElement("button", {
                  className: styles["action-confirm"],
                  onClick: (function (param) {
                      Curry._1(on_confirm, undefined);
                    })
                }, waypoint ? SpotEstimateStore$PorterinFeature.confirm_drop_action_label : SpotEstimateStore$PorterinFeature.confirm_pickup_action_label));
}

var make = ConfirmLocationActionCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
